module.exports = __webpack_public_path__ + "static/media/figure1.9deae273.jpg";